import { Component, OnInit, ViewChild } from '@angular/core';
import { LoginService } from '../service/login.service';
import { TarjetasService } from '../service/tarjetas.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pocae',
  templateUrl: './pocae.component.html',
  styleUrls: ['./pocae.component.scss']
})
export class PocaeComponent implements OnInit {
  session: any;
  cards: any;
  load = false;
  errorMensaje: any;

  constructor(private login: LoginService, private tarjetas: TarjetasService, private router: Router) {
    const sesion = localStorage.getItem('sesionPocae');

    if (!sesion) {
      this.router.navigate(['/'])
    }
  }
  ngOnInit() {
  }

  ngOnDestroy() {

  }

}

